import React from "react";

import { Flex, Typography } from "antd";
import { Link } from "react-router-dom";

import logo from "../../../img/logo.png";

type Props = {
  compact?: boolean;
};

function BrandLogo({ compact = false }: Props) {
  return (
    <Link to="/" aria-label="Digital Logist" style={{ color: "inherit" }}>
      <Flex align="center" gap={10}>
        <span
          aria-hidden="true"
          style={{
            backgroundColor: "currentColor",
            display: "inline-block",
            flex: "0 0 36px",
            height: 36,
            mask: `url(${logo}) center / contain no-repeat`,
            WebkitMask: `url(${logo}) center / contain no-repeat`,
            width: 36,
          }}
        />
        {!compact && (
          <Typography.Text strong style={{ color: "inherit", fontSize: 18, letterSpacing: -0.4, whiteSpace: "nowrap" }}>
            Digital Logist
          </Typography.Text>
        )}
      </Flex>
    </Link>
  );
}

export default React.memo(BrandLogo);
